"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = exports.Relationships = exports.DOCXMargin = void 0;
exports.wrapDOCXComponent = wrapDOCXComponent;
exports.makeComponentWithTag = makeComponentWithTag;
const react_1 = __importDefault(require("react"));
exports.DOCXMargin = "　";
function wrapDOCXComponent(docxComponentID, Component) {
    void docxComponentID;
    const ret = ((props) => {
        return react_1.default.createElement(Component, { ...props });
    });
    ret.componentID = docxComponentID;
    return ret;
}
function makeComponentWithTag(tag) {
    const func = function ComponentWithTag(props) {
        return react_1.default.createElement(tag, props);
    };
    func.displayName = `ComponentWithTag<${tag}>`;
    return func;
}
const RelationshipsTag = makeComponentWithTag("Relationships");
const Relationship = makeComponentWithTag("Relationship");
const Relationships = props => (react_1.default.createElement(RelationshipsTag, { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" }, props.relationships.map((r, key) => react_1.default.createElement(Relationship, { ...r, key: key }))));
exports.Relationships = Relationships;
const TypesTag = makeComponentWithTag("Types");
const Default = makeComponentWithTag("Default");
const Override = makeComponentWithTag("Override");
const Types = props => (react_1.default.createElement(TypesTag, { xmlns: "http://schemas.openxmlformats.org/package/2006/content-types" }, props.types.map((type, key) => type.tag === "Default"
    ? react_1.default.createElement(Default, { key: key, Extension: type.Extension, ContentType: type.ContentType })
    : react_1.default.createElement(Override, { key: key, PartName: type.PartName, ContentType: type.ContentType }))));
exports.Types = Types;
//# sourceMappingURL=component.js.map